import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import { ProductDto } from '../../services/expensesApi';

interface ProductDetailProps {
  product: ProductDto;
}

const ProductDetail: React.FC<ProductDetailProps> = ({ product }) => {
  return (
    <Paper sx={{ p: 2 }}>
      <Typography variant="h6">Detalhes do produto</Typography>
      <Box>
        <Typography><b>Nome:</b> {product.name}</Typography>
        <Typography><b>Código:</b> {product.code || 'N/D'}</Typography>
        <Typography><b>Descrição:</b> {product.description}</Typography>
        <Typography><b>Quantidade:</b> {product.quantity}</Typography>
      </Box>
    </Paper>
  );
};

export default ProductDetail;
